import { Reviewer } from "components/Submission/ReviewersEditList";
import { ReviewMode } from "generated-graphql/graphql";
import { SubmissionReviewerSigner } from "hooks/useSubmissionForm";
import { useState } from "react";

/** Open/closed state for every dialog on the Reviewer Preparation step. */
export function useReviewerPreparationDialogState() {
  const [reviewerDialogOpen, setReviewerDialogOpen] = useState(false);
  const [signerDialogOpen, setSignerDialogOpen] = useState(false);
  const [preparationDialogOpen, setPreparationDialogOpen] = useState(false);
  const [rejectionRoutingOpen, setRejectionRoutingOpen] = useState(false);
  const [advanceConfirmOpen, setAdvanceConfirmOpen] = useState(false);
  const [finalApprovalReviewers, setFinalApprovalReviewers] = useState<Reviewer[] | null>(null);
  // Signer/reviewer mutual-exclusion confirmations (one person can't be both).
  // The pending save carries its review mode so confirming applies exactly what
  // the dialog chose, not just the reviewer list.
  const [reviewersToConfirm, setReviewersToConfirm] = useState<{
    reviewers: Reviewer[];
    reviewMode: ReviewMode;
  } | null>(null);
  const [signerToConfirm, setSignerToConfirm] = useState<SubmissionReviewerSigner | null>(null);

  return {
    reviewerDialogOpen,
    setReviewerDialogOpen,
    signerDialogOpen,
    setSignerDialogOpen,
    preparationDialogOpen,
    setPreparationDialogOpen,
    rejectionRoutingOpen,
    setRejectionRoutingOpen,
    advanceConfirmOpen,
    setAdvanceConfirmOpen,
    finalApprovalReviewers,
    setFinalApprovalReviewers,
    reviewersToConfirm,
    setReviewersToConfirm,
    signerToConfirm,
    setSignerToConfirm,
  };
}
